import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'perUnit',
    standalone: true
})
export class PerUnitPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) {
            return value;
        }
        return value.replace(/ per /g, '/');
    }
}